import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import Drawer from "@mui/material/Drawer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { EmailShareButton, WhatsappShareButton } from "react-share";
import { EmailIcon, WhatsappIcon } from "react-share";

import { getOrder } from "../../../redux/actions-exporter";
import Header from "../../header/Header";

import "./styles.css";

const Index = () => {
  const dispatch = useDispatch();
  const { orderId } = useParams();
  const currentOrder = useSelector((state) => state.order.order);
  const [timer, setTimer] = useState(false);
  const [order, setOrder] = useState(false);
  const [share, setShare] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getOrder(orderId));

    if (!timer) {
      setTimer(setInterval(() => dispatch(getOrder(orderId)), 2000));
    }
  }, [orderId]); // eslint-disable-line

  useEffect(() => {
    if (!order?.id) {
      setOrder(currentOrder);
    }

    if (currentOrder?.metadata?.cardNumber) {
      clearInterval(timer);
      setOrder(currentOrder);
    }
  }, [currentOrder, order]); // eslint-disable-line

  return (
    <div className="pageTemplate">
      <Header isFull={false} />
      <div className="container">
        <hr />
        <div className="templateHeading">
          <h1 className="templateTitle">{t("payment approve")}</h1>
        </div>
        <hr />
        <div className="paymentApproveContent">
          <div className="paymentApproveText">
            <h6 className="pelecard-page__info">
              סכום החשבון: {order?.total || 0} ₪
            </h6>
            <h5 className="pelecard-page__title">
              תשלום בסך {order?.total * order?.metadata?.discount || 0} ₪ בוצע
              בהצלחה
            </h5>
            <h5 className="paymentApproveLine1">
              {order?.metadata?.cardNumber ? (
                <>קוד מולטיפס: {order?.metadata?.cardNumber}</>
              ) : (
                <>{t("Loading card")}...</>
              )}
            </h5>
            <h5 className="pelecard-page__info">(להצגה בקופה)</h5>
            {order?.metadata?.cardPin ? <>{order?.metadata?.cardPin}</> : ""}
          </div>
          <div className="loadMoneyCard-btn">
            <Button
              className="blueBtn"
              onClick={() => {
                navigate("/");
              }}
            >
              {t("end")}
            </Button>
            {order?.metadata?.cardNumber ? (
              <Button
                className="blueBtn gift"
                onClick={() => {
                  // navigate("/");
                  setShare(true);
                }}
              >
                שתף כמתנה
              </Button>
            ) : (
              ""
            )}
            <Drawer
              className="callOrChat"
              PaperProps={{
                sx: {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  width: "200px",
                  top: "400px",
                  left: "20px",
                  height: "100px",
                  margin: "auto",
                  borderRadius: "60px",
                  padding: "10px",
                },
              }}
              open={share}
              onClose={() => setShare(false)}
              anchor="left"
            >
              <a className="f6 grow no-underline br-pill ph3 pv2 mb2 dib ">
                <EmailShareButton
                  // className='share'
                  url={"#"}
                  subject="מתנה מ-Icl!"
                  body={`קוד מולטיפס (להצגה בקופה): ${
                    order?.metadata?.cardNumber || 12345678
                  } \nפינקוד: ${order?.metadata?.cardPin || 1234}`}
                >
                  <EmailIcon size={55} round />
                </EmailShareButton>
              </a>
              <a className=" f6 grow no-underline br-pill ph3 pv2 mb2 dib ">
                <WhatsappShareButton
                  // title="מתנה מ-Icl!"
                  // body={`קוד מולטיפס (להצגה בקופה): ${order?.metadata?.cardNumber || 12345678
                  //   } \nפינקוד: ${order?.metadata?.cardPin || 1234}`}
                  // url={"#"}
                  title="מתנה מ-Icl!"
                  separator={"\n"}
                  url={`קוד מולטיפס (להצגה בקופה): ${
                    order?.metadata?.cardNumber || 12345678
                  } \nפינקוד: ${order?.metadata?.cardPin || 1234}`}
                >
                  <WhatsappIcon size={55} round />
                </WhatsappShareButton>
              </a>
            </Drawer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
